import { useCallback } from "react"
import { createModel } from "hox"
import { useSetState } from "ahooks-v2"

interface eidArgs {
  eid: string
  refreshCount: number
}
function useEid() {
  const [state, set] = useSetState<eidArgs>({
    eid: "",
    refreshCount: 0,
  })
  const setEid = useCallback(
    (value: string) => {
      set({
        eid: value,
      })
    },
    [set],
  )
  const setRefreshCount = useCallback(
    (value: number) => {
      set({
        refreshCount: value,
      })
    },
    [set],
  )
  const setAllState = useCallback(
    (value: Partial<eidArgs> | ((prevState: eidArgs) => Partial<eidArgs>)) => {
      set(value)
    },
    [set],
  )
  return {
    ...state,
    setEid,
    setRefreshCount,
    setAllState,
  }
}
export default createModel(useEid)
